module.exports = __webpack_public_path__ + "static/media/twitter-white.d45142fb.svg";